/**
 * @desc        Notification
 * @version     1.1 - 1 Feb 22 **/

import * as actionTypes from 'redux/actions/action-types.js'

const initialState = {
    data: {
        items: [],
    },
    lastFetch: 0,
    loading: false,
    loginError: null,
    refreshError: null,
}

const notification = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STORE_INIT:
            return {
                ...initialState,
            }
        case actionTypes.FD_NOTIFICATIONS_SIGNIN:
            return {
                ...state,
                loading: false,
                lastFetch: Date.now(),
                signedIn: action?.signedIn,
            }
        case actionTypes.FD_NOTIFICATIONS_SIGNIN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                lastError: Date.now(),
            }

        case actionTypes.FD_NOTIFICATIONS_SET:
            return {
                ...state,
                lastFetch: Date.now(),
                loading: false,
                data: {
                    ...state.data,
                    items: action.data,
                },
            }

        default: {
            return state
        }
    }
}

export default notification
